// Scope Escape to the top availability overlay, rather than closing its parent.
export const AvailabilityOverlay = {
  mounted() {
    this.previousFocus = document.activeElement;
    this.onOverlayKey = event => {
      if (event.key !== "Escape") return;
      const overlays = [...document.querySelectorAll("[data-availability-overlay]")];
      const top = overlays.reduce((current, el) =>
        !current || Number(window.getComputedStyle(el).zIndex) >= Number(window.getComputedStyle(current).zIndex) ? el : current, null);
      if (top !== this.el) return;
      const { componentId, closeEvent } = this.el.dataset;
      if (!componentId || !["close_date_picker", "dismiss_preview"].includes(closeEvent)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      this.pushEventTo(`#${componentId}`, closeEvent, {});
    };
    window.addEventListener("keydown", this.onOverlayKey, true);
  },
  destroyed() {
    window.removeEventListener("keydown", this.onOverlayKey, true);
    const other = [...document.querySelectorAll("[data-availability-overlay]")].some(el => el !== this.el);
    if (!other && this.previousFocus?.isConnected) this.previousFocus.focus({ preventScroll: true });
  }
};
